import { render, staticRenderFns } from "./bTab.vue?vue&type=template&id=67681bee&"
import script from "./bTab.vue?vue&type=script&lang=js&"
export * from "./bTab.vue?vue&type=script&lang=js&"
import style0 from "./bTab.vue?vue&type=style&index=0&id=67681bee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports